import { useEffect, useState } from "react";
import { reverseGeocode, cachedAddress, coordsText } from "@/lib/geocode";

// Affiche « adresse + ville » (géocodage inverse, cache partagé). Repli explicite sur les
// coordonnées si l'adresse est indisponible. Les coordonnées restent en info-bulle (title).
export function AddressLabel({ lat, lon, className, showCoordsFallback = true, testid }) {
  const [addr, setAddr] = useState(() => cachedAddress(lat, lon));

  useEffect(() => {
    let alive = true;
    if (lat == null || lon == null) { setAddr(""); return; }
    const c = cachedAddress(lat, lon);
    if (c !== undefined) { setAddr(c); return; }
    setAddr(undefined);
    reverseGeocode(lat, lon).then((a) => { if (alive) setAddr(a); });
    return () => { alive = false; };
  }, [lat, lon]);

  if (lat == null || lon == null)
    return <span className={className} data-testid={testid}>—</span>;
  if (addr === undefined)
    return <span className={className} data-testid={testid}>Localisation…</span>;
  if (addr)
    return <span className={className} data-testid={testid} title={coordsText(lat, lon)}>{addr}</span>;
  return (
    <span className={className} data-testid={testid}>
      {showCoordsFallback ? coordsText(lat, lon) : "Adresse indisponible"}
    </span>
  );
}

export default AddressLabel;
